<template>
  <div class="dft-container" style="overflow-y: auto;">

    <div class="dft-search">
      <el-tabs v-model="activeName" @tab-click="handleClick" class="search_tab">
        <el-tab-pane :label="'已领取' + '(' + receiveCount + ')' " name="1"></el-tab-pane>
        <el-tab-pane :label="'待领取' + '(' + unclaimedCount + ')'" name="0"></el-tab-pane>
        <el-tab-pane :label="'转赠中' + '(' + transferCount + ')'" name="2"></el-tab-pane>
      </el-tabs>
      <el-form label-width="120px" label-height="40px" class="dft-form_class">
        <el-row>
          <el-col :span="8">
            <el-form-item label="创建时间" prop="routeName">
              <el-date-picker v-model="daterange" value-format="yyyy-MM-dd" type="daterange" style="width: 100%;"
                @change="handleDateChange" range-separator="-" unlink-panels clearable start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="储值卡ID:" prop="storeCardNo">
              <el-input v-model="queryInfo.condition.storeCardNo" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="储值卡名称:" prop="storeCardName">
              <el-input v-model="queryInfo.condition.storeCardName" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-col :span="8" v-if="activeName === '1'">
          <el-form-item label="领取人昵称:" prop="openTime">
            <el-input v-model="queryInfo.condition.memberName" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="activeName === '1'">
          <el-form-item label="领取人手机号码:" prop="openTime">
            <el-input v-model="queryInfo.condition.memberPhone" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24" style="display: flex; justify-content: space-between;margin-bottom: 8px;">
          <div>
            <el-button @click="newBtn" type="primary" icon="el-icon-plus">新赠</el-button>
            <el-button @click="toExport" type="success" :loading="btnloading" icon="el-icon-download">导出</el-button>
          </div>
          <div> <el-button @click="reset" icon="el-icon-refresh-left">重置</el-button>
            <el-button type="primary" @click="search" icon="el-icon-search">查询</el-button>
          </div>
        </el-col>
      </el-form>
    </div>
    <div class="tab">
      <el-table v-loading="loading" border max-height="100%" ref="search_d" key="search_d" :data="tableData"
        tooltip-effect="dark" style="width: 100%;margin-top: 5px;" :height="height1">
        <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
        <el-table-column label="储值卡ID" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.storeCardNo }}</template>
        </el-table-column>
        <el-table-column label="储值卡名称"  width="150"  align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.storeCardName }}</template>
        </el-table-column>
        <el-table-column label="储值卡图片"  width="150"  align="center">
          <template slot-scope="scope">
            <el-image :preview-src-list="[scope.row.logo]" :src="scope.row.logo" class="table-img" />
          </template>
        </el-table-column>
        <el-table-column label="面值" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.cardValue }}</template>
        </el-table-column>
        <el-table-column label="剩余额度" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.balance }}</template>
        </el-table-column>
        <el-table-column label="领取人头像" width="150"  align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-image style="width: 50px;height: 50px;border-radius: 50%;" :preview-src-list="[scope.row.memberLogo]"
              v-if="scope.row.memberLogo" :src="scope.row.memberLogo" class="table-img" />
          </template>
        </el-table-column>
        <el-table-column label="领取人昵称"  width="150"  align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.memberName }}</template>
        </el-table-column>
        <el-table-column label="领取人手机号" width="150" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.memberPhone }}</template>
        </el-table-column>
        <el-table-column label="储值卡密码" width="150"  align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.pwd }}</template>
        </el-table-column>
        <el-table-column label="领取时间" width="150"  align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.getTime }}</template>
        </el-table-column>
        <el-table-column label="操作" width="135" align="center">
          <template slot-scope="scope">
            <el-button v-if="activeName == '1'" type="text" @click="getDetail(scope.row)" size="small">查看明细</el-button>
            <div v-if="activeName === '0'">
              <el-button type="text" @click="edit(scope.row)" size="small" style="margin-right: 10px;">编辑</el-button>
              <el-popconfirm title="确定删除吗？" @confirm="handleDelete(scope.row.id)">
                <el-button slot="reference" type="text" style="color: red;">删除</el-button>
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="queryInfo.currPage" :page-sizes="[100, 200, 300, 400]" :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog v-loading="detailLoading" title="查看明细" :visible.sync="showDetailDialog" width="1000px">
      <el-descriptions :column="4" title="">
        <el-descriptions-item label="用户">{{ obj.memberName }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ obj.memberPhone }}</el-descriptions-item>
        <el-descriptions-item label="剩余金额">
          <div style="color: red">{{ obj.balance }}</div>
        </el-descriptions-item>
        <el-descriptions-item label="领取时间">{{ obj.getTime }}</el-descriptions-item>
      </el-descriptions>
      <el-form label-width="100px" label-height="60px">
        <el-row>
          <el-col :span="10">
            <el-form-item label="订单号:" prop="storeName">
              <el-input v-model="queryDetailInfo.condition.orderNumber" placeholder="请输入" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="消费时间:" prop="name">
              <el-date-picker class="select-date" v-model="queryDetailInfo.condition.orderTimeArr" placeholder="请输入"
                type="datetimerange" value-format="yyyy-MM-dd hh:mm:ss" :default-time="['', '23:59:59']"
                clearable></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-col :span="24" style="display: flex; justify-content: flex-end">
          <div> <el-button @click="detailReset" icon="el-icon-refresh-left">重置</el-button>
            <el-button type="primary" @click="detailSearch" icon="el-icon-search">搜索</el-button>
          </div>
        </el-col>
      </el-form>
      <div class="tab">
        <el-table border max-height="100%" ref="search_d_detail" key="search_d_detail" :data="tableDetailData"
          tooltip-effect="dark" style="width: 100%;margin-top: 5px;" :height="height2">
          <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
          <el-table-column label="订单明细" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-image style="width: 30px; height: 30px;margin: 5px" :preview-src-list="[item.listImg, item.listImg]"
                :src="item.listImg" v-for="(item, index) in scope.row.orderItems" :key="index" />
            </template>
          </el-table-column>
          <el-table-column label="订单编号" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.orderNumber }}</template>
          </el-table-column>
          <el-table-column label="消费时间" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.orderTime }}</template>
          </el-table-column>
          <el-table-column label="支付金额" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.useMemberStoreCardsBalance }}</template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="block">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="queryDetailInfo.currPage" :page-sizes="[50, 100, 150, 200]"
            :page-size="queryDetailInfo.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="detailTotal">
          </el-pagination>
        </div>
      </div>
    </el-dialog>

    <el-dialog :title="(labelType == 'add' ? '新赠' : '编辑')" :visible.sync="showDialog" width="800px">

      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-row :gutter="10">
          <el-col :span="span">
            <el-form-item label="储值卡名称" prop="storeCardName">
              <el-input :disabled="disabled" v-model="form.storeCardName" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="span">
            <el-form-item label="面值" prop="pwd">
              <el-input v-model="form.cardValue" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="labelType == 'add'" :span="span">
            <el-form-item label="卡号前缀" prop="cardNoLetter">
              <el-input :disabled="disabled" v-model="form.cardNoLetter" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="labelType == 'add'" :span="span">
            <el-form-item label="卡号初始数字" prop="cardNoNum">
              <el-input :disabled="disabled" v-model="form.cardNoNum" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="labelType == 'add'" :span="span">
            <el-form-item label="数量" prop="number">
              <el-input :disabled="disabled" v-model="form.number" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="span">
            <el-form-item label="储值卡封面：" prop="logo">
              <upLoadFile :imgURL="form.logo" @delImg="delImg" style="margin-right: 350px" @addImg="addImg">
              </upLoadFile>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="showDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleSave" :loading="btnloading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import upLoadFile from '../../components/upLoadFile.vue'
import it from 'element-ui/src/locale/lang/it'

export default {
  computed: {
    it () {
      return it
    }
  },
  components: { upLoadFile },
  data () {
    return {
      loading: false,
      detailLoading: false,
      showDetailDialog: false,
      labelType: 'add',
      rules: {},
      total: 0,
      detailTotal: 0,
      queryInfo: {
        pageSize: 100,
        pageCount: 1,
        currPage: 1,
        condition: { createTimeArr: [], limitTimeArr: [] }
      },
      tableDetailData: [],
      queryDetailInfo: {
        pageSize: 30,
        pageCount: 1,
        currPage: 1,
        condition: { orderTimeArr: [] }
      },
      form: {
        logo: ''
      },
      showDialog: false,
      tableData: [],
      height1: window.innerHeight - 297, // 表格高度
      height2: window.innerHeight - 242, // 表格高度
      headerHeight: 0,
      activeName: '1',
      // 已领取数量
      receiveCount: 0,
      // 未领取数量
      unclaimedCount: 0,
      transferCount:0,
      count: 0,
      span: 0,
      disabled: false,
      obj: {},
      daterange: [],
      btnloading: false
    }
  },

  created () {
    this.getList()
  },

  mounted () {
    this.queryInfo.condition.receiveStatus = 1
    /* this.$nextTick(() => {
       // 获取定义ref属性 和 元素高度
       this.headerHeight = this.$refs.search_d.offsetHeight;
       window.addEventListener('resize', this.getHeight())
     }) */
  },

  methods: {
    detailSearch () {
      var orderTimeArr = this.queryDetailInfo.condition.orderTimeArr
      if (orderTimeArr !== null && orderTimeArr !== '') {
        if (orderTimeArr.length > 0) {
          this.queryDetailInfo.condition.orderTimeStart = orderTimeArr[0]
          this.queryDetailInfo.condition.orderTimeEnd = orderTimeArr[1]
        }
      } else {
        this.queryDetailInfo.condition.orderTimeStart = null
        this.queryDetailInfo.condition.orderTimeEnd = null
      }
      this.getOne(this.obj)
    },
    handleDateChange (val) {
      this.queryInfo.condition.startTime = val[0]
      this.queryInfo.condition.endTime = val[1]
    },
    // 消费明细
    getDetail (row) {
      if (row.memberCode != null && row.memberCode != '') {
        this.obj = row
        this.labelType = 'info'
        this.getOne()
        this.showDetailDialog = true
      } else {
        this.$message({
          message: '该储值卡未绑定领取人',
          type: 'warning'
        })
      }
    },
    reset () {
      // 初始化 queryInfo.condition
      this.queryInfo.condition = {
        createTimeArr: [],
        limitTimeArr: []
      }

      // 根据 activeName 设置 receiveStatus
      if (this.activeName === '1') {
        this.queryInfo.condition.receiveStatus = 1
      } else if (this.activeName === '0') {
        this.queryInfo.condition.receiveStatus = 0
      };
      this.getList()
    },
    // 图片上传成功处理
    handleAddUploadSuccess (res, file) {
      this.form.logo = file.response.data.url
      this.$forceUpdate() // 触发强制刷新
    },
    // 图片上传之前处理
    beforeUpload (file) {
    },
    search () {
      var createTimeArr = this.queryInfo.condition.createTimeArr
      var limitTimeArr = this.queryInfo.condition.limitTimeArr
      if (createTimeArr !== null) {
        if (createTimeArr.length != 0) {
          this.queryInfo.condition.createStartTime = createTimeArr[0]
          this.queryInfo.condition.createEndTime = createTimeArr[1]
        }
      } else {
        this.queryInfo.condition.createStartTime = null
        this.queryInfo.condition.createEndTime = null
      }
      if (limitTimeArr !== null) {
        if (limitTimeArr.length != 0) {
          this.queryInfo.condition.limitStartTime = limitTimeArr[0]
          this.queryInfo.condition.limitEndTime = limitTimeArr[1]
        }
      } else {
        this.queryInfo.condition.limitStartTime = null
        this.queryInfo.condition.limitEndTime = null
      }
      this.getList()
    },
    getCountByReceiveStatus () {
      var that = this
      that.$http.post('/memberStoreCard/count').then(function (response) {
        if (response.data.code == 200) {
          var res = response.data.data
          // 已领取数量
          that.receiveCount = res.receiveCount
          // 未领取数量
          that.unclaimedCount = res.unReceiveCount
          // 待领取
          that.transferCount = res.transferCount
        }
      })
    },
    detailReset () {
      this.queryDetailInfo = {
        pageSize: 30,
        pageCount: 1,
        currPage: 1,
        condition: { orderTimeArr: [] }
      }
    },
    handleClick (tab) {
      switch (tab.name) {
        case '1':
          this.queryInfo.condition.receiveStatus = 1
          break
        case '0':
          this.queryInfo.condition.receiveStatus = 0
          this.queryInfo.condition.status =1
          delete this.queryInfo.condition.memberName
          delete this.queryInfo.condition.memberPhone
          break
        case '2':
          // this.queryInfo.condition.receiveStatus = 0
          this.queryInfo.condition.status =2
          delete this.queryInfo.condition.memberName
          delete this.queryInfo.condition.memberPhone
          break
        default:
          break
      }
      this.getList()
    },
    // 监听表格高度
    /*  getHeight () {
        this.height = window.innerHeight - this.headerHeight - 256;

      }, */

    // 随机卡号
    async randomCardNo (form, NO) {
      await that.$http.post('/', that.queryDetailInfo).then(res => {
        if (res.data.code == 200) {
          // that.detailTotal = res.data.data.count
        }
      })
    },
    // 随机密码
    randomPwd (form, pwd) { },
    // 获取数据
    getList () {
      this.getCountByReceiveStatus()
      this.loading = true
      var that = this
      that.$http.post('/memberStoreCard/list', that.queryInfo).then(function (response) {
        if (response.data.code == 200) {
          that.total = response.data.data.count
          that.queryInfo.currPage = response.data.data.currPage
          that.tableData = response.data.data.data
          that.loading = false
        }
      })
    },

    // 获取数据
    async getOne () {
      var that = this
      that.detailLoading = true
      that.queryDetailInfo.condition.memberStoreCardsCode = that.obj.storeCardCode
      that.queryDetailInfo.condition.memberCode = that.obj.memberCode
      await that.$http.post('/order/list', that.queryDetailInfo).then(function (response) {
        console.log(response.data.data, 1211)
        if (response.data.code == 200) {
          that.detailTotal = response.data.data.count
          that.tableDetailData = response.data.data.data
          that.detailLoading = false
        }
      })
    },

    async toExport () {
      // if (this.btnloading) {
      //   return
      // }
      // this.btnloading = true
      // const that = this
      // // const a = this.activeName
      // that.$http.post('/exportExcel/exportStoreCard', that.queryInfo,
      // { responseType: "blob" }).then(response => {
      //   if (response.data.code == 200) {
      //     // 获取文件下载链接
      //     const fileUrl = window.URL.createObjectURL(new Blob([response.data]));
      //     // window.open(fileUrl, "_blank");
      //     const link = document.createElement("a");
      //     link.href = fileUrl
      //     link.target = '_blank'
      //     link.setAttribute("download", `储值卡明细.xls`); // 设置导出的文件名称
      //     document.body.appendChild(link);
      //     link.click();
      //     document.body.removeChild(link);
      //     that.$message({ type: "success", message: "导出成功" });
      //   } else {
      //     that.$notify.info({
      //       title: "提示",
      //       message: response.data.message,
      //       showClose: true,
      //     });
      //   }
      //   that.btnloading = false
      // }).catch(error => {
      //   that.btnloading = false
      // })

      const loading = this.$loading({
        lock: true,
        text: '正在导出中，请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const that = this
      let url = '/exportExcel/exportStoreCard'
      const res = await this.$http.post(url, that.queryInfo,
        { responseType: 'blob' })
      if (res.status == 200) {
        try {
          const fileUrl = window.URL.createObjectURL(new Blob([res.data]))
          const link = document.createElement('a')
          link.href = fileUrl
          link.target = '_blank'
          link.setAttribute('download', `储值卡数据表格.xls`) // 设置导出的文件名称
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          loading.close()
          that.$message({ type: 'success', message: '导出成功' })
        } catch (error) {
          this.$message.error(error)
        }
      }
    },
    // 保存 /memberStoreCard/save /memberStoreCard/generateBatch
    handleSave () {
      if (this.btnloading) {
        return
      }
      this.btnloading = true
      var that = this
      const _url = this.labelType == 'add' ? 'memberStoreCard/insertBatch' : 'memberStoreCard/update'
      const _data = this.labelType == 'add' ? that.form : {
        id: that.form.id,
        storeCardName: this.form.storeCardName,
        cardValue: this.form.cardValue,
        logo: this.form.logo
      }
      that.$http.post(_url, _data).then(response => {
        if (response.data.code == 200) {
          that.$notify.success({
            title: '提示',
            message: this.labelType == 'add' ? '保存成功' : '修改成功',
            showClose: true
          })
          that.showDialog = false
          that.getList()
        } else {
          that.$notify.info({
            title: '提示',
            message: response.data.message,
            showClose: true
          })
        }
        that.btnloading = false
      }).catch(function (error) {
        that.btnloading = false
      })
    },

    // 修改
    edit (row) {
      this.disabled = false
      this.span = 18
      this.labelType = 'edit'
      this.form = row
      this.showDialog = true
    },

    // 删除当前行
    //    handleDelete (id) {
    //      del({ id: id }).then(res => {
    //        if (res.code == 200) {
    //         this.$message.success('删除成功')
    //         this.getList()
    //       }
    //      })
    //    },

    // 删除用户
    async handleDelete (id) {
      const confirmResult = await this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => err)
      if (confirmResult === 'confirm') {
        var that = this
        that.$http.post('/memberStoreCard/delete', { 'id': id }).then(function (response) {
          if (response.data.code == 200) {
            that.$notify.success({
              title: '提示',
              message: '删除成功',
              showClose: true
            })
            that.getList()
          } else {
            that.$notify.info({
              title: '提示',
              message: response.data.message,
              showClose: true
            })
          }
        })
      }
    },

    // 新赠按钮
    newBtn () {
      this.disabled = false
      this.labelType = 'add'
      this.showDialog = true
      this.form = {}
      this.span = 18
      this.form.startCode = 'STJN' + this.getDateFormat()
    },
    // 获取格式时间YYYY-MM-dd字符串
    getDateFormat () {
      // 获取当前时间
      let currentTime = new Date()

      // 获取年份
      let year = currentTime.getFullYear()

      // 获取月份（注意月份是从0开始计数的，所以需要加1）
      let month = currentTime.getMonth() + 1

      // 获取日期
      let day = currentTime.getDate()
      return `${year}${month.toString().padStart(2, '0')}${day.toString().padStart(2, '0')}`
    },

    // 修改页数大小
    handleSizeChange (val) {
      this.queryInfo.pageSize = val
      this.span = 12
      this.getList()
    },

    // 获取当前页面
    handleCurrentChange (val) {
      this.queryInfo.currPage = val
      this.getList()
    },

    delImg (val) {
      this.form.logo = ''
    },
    addImg (text, val) {
      this.$set(this.form, 'logo', val)
    }

  }
}
</script>

<style scoped lang="scss">
.search-top {
  height: 33px;
  padding: 2px 2px 2px 2px;
  background-color: rgba(30, 152, 215, 0.14);

  display: flex;
  align-items: center;
  margin-bottom: 10px;

  div {
    width: 150px;
    text-align: center;
  }

}

.tab {
  flex: 1;
}

.select-date {
  width: 255px;
}

// .table-img{
//   width: 150px;
//   height: 50px;
//   // display: block;
//   object-fit: cover; /* 确保图片按比例裁剪以适应容器 */
// }
/* 在你的样式文件中定义 */
.table-img {
  width: 100px;
  /* 设置图片宽度 */
  height: 50px;
  /* 设置图片高度 */
  object-fit: cover;
  /* 确保图片按比例裁剪以适应容器 */
}
</style>
